export default __webpack_public_path__ + "static/media/cowboyKlein.7cf73885.jpg";